import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../../hooks/useTranslation'

export const PurchaseInfoGuideTooltip = (props: any) => {
  const { setIsOpenPurchaseInfoGuideModal } = props
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white   h-auto  border-[3px] border-main  rounded-[20px] text-black font-medium w-[330px]',
        {
          ' fixed left-[40%] bottom-[10%]  z-50 ': !isMobile,
          ' absolute left-2  z-50 ': isMobile,
        }
      )}
    >
      <p className=" md:leading-[19.2px] md:text-base  leading-[12px] text-[10px] flex items-center justify-between">
        <span className="font-bold text-[20px]">{t('productVideoEditor.purchaseInfoGuideTooltip.title')}</span>
        <img
          src="assets/img/Icon_x.png"
          alt="icon_x"
          height={24}
          width={24}
          onClick={() => {
            setIsOpenPurchaseInfoGuideModal(false)
          }}
          className=" cursor-pointer"
        />
      </p>
      <p>
        {t('productVideoEditor.purchaseInfoGuideTooltip.description1')} <br />
        <span className="text-error">{t('productVideoEditor.purchaseInfoGuideTooltip.duration')}</span> {t('productVideoEditor.purchaseInfoGuideTooltip.description2')}, <br />{' '}
        {t('productVideoEditor.purchaseInfoGuideTooltip.description3')}
      </p>
      <p>
        <img src="assets/img/purchaseInfoGuide.png" alt="" />
      </p>
    </div>
  )
}
